const HELP_SITE_LANGUAGES = ['nl', 'fr', 'en'] as const;

/* A language the public help site is not written in reads English. */
export function helpUrl(locale: string, page = ''): string {
  const lang = (HELP_SITE_LANGUAGES as readonly string[]).includes(locale)
    ? locale
    : 'en';
  return `https://help.wundo.ai/${lang}/${page}`;
}
